/**
 * PROVISIONING-FLOW-FRONTEND-1 — helpers PUROS do fluxo de provisionamento do
 * InstallerPortal (Cliente × Infraestrutura/Torre). Extraídos p/ teste em node.
 */

// INSTALLER-TEMPLATES-UX-2 — opções da etapa Template, NA ORDEM de exibição.
// "custom" (Sem template / Configurar depois) é o primeiro e o padrão seguro.
// Valores internos inalterados: custom | residential | business.
export const INSTALLER_TEMPLATE_OPTIONS = [
  {
    id: "custom",
    name: "Sem template / Configurar depois",
    desc: "Não aplica nenhuma configuração automática agora. O equipamento poderá ser configurado depois pelo NOC.",
    badge: "Padrão seguro",
    recommended: true,
  },
  {
    id: "residential",
    name: "Residencial",
    desc: "Aplica watchdog padrão para cliente residencial e reboot preventivo semanal.",
    badge: "Aplica comandos automáticos",
  },
  {
    id: "business",
    name: "Empresarial",
    desc: "Aplica watchdog conservador em modo alerta, sem reboot automático do relé.",
    badge: "Sem reboot automático",
  },
];

/** Padrão seguro inicial da etapa Template. */
export const DEFAULT_INSTALLER_TEMPLATE = "custom";

/** Rótulo + nota para o resumo final. custom (ou ausente) deixa claro que nada
 *  automático é aplicado. */
export function templateSummary(templateId) {
  if (!templateId || templateId === "custom") {
    return {
      label: "Sem template / Configurar depois",
      note: "Nenhuma configuração automática será aplicada.",
    };
  }
  const opt = INSTALLER_TEMPLATE_OPTIONS.find((o) => o.id === templateId);
  return { label: opt ? opt.name : templateId, note: null };
}

/** Passos dinâmicos do wizard por tipo. Infra NÃO passa por Cliente/Template
 *  (sem IXC). */
export function stepsFor(deploymentType) {
  return deploymentType === "infrastructure"
    ? ["equipment", "type", "infra", "finish"]
    : ["equipment", "type", "customer", "template", "finish"];
}

/** Detecta o IXC restrito: 401 (sem auth) OU 403 (autenticado mas sem permissão,
 *  ex.: técnico field — IXC é platform-only). Mensagem amigável, sem reabrir IXC. */
export function isIxcProtected(err) {
  if (!err) return false;
  if (err.status === 401 || err.status === 403) return true;
  return /authentication required|protegid|unauthor|forbidden|permiss/i.test(
    String(err.message || "")
  );
}

/** Mensagem amigável p/ o IXC restrito (FIELD-IXC-AUTH-BRIDGE-1):
 *  - NÃO logado (401): precisa logar como técnico;
 *  - logado mas SEM permissão (403, ex.: viewer): mensagem amigável de permissão.
 *  Usuário logado e permitido (field/noc/tenant_admin/super_admin) recebe 200 e
 *  esta mensagem não aparece. */
export function ixcRestrictedMessage(loggedIn) {
  return loggedIn
    ? "Sua conta não tem permissão para buscar clientes IXC. Use Infraestrutura/Torre ou peça liberação via NOC."
    : "Faça login como técnico para buscar clientes IXC, ou use o fluxo de Infraestrutura/Torre.";
}

/** Monta o bloco `provisioning` da Infra para gravar em
 *  installation_sessions.raw_json.provisioning. Coordenada só vai se válida;
 *  origem 'manual' quando o técnico edita lat/lng à mão. */
export function buildInfraProvisioning({
  operationalIdentifier,
  hardwareCapability,
  category,
  displayName,
  notes,
  lat,
  lng,
  accuracyM,
  locationSource,
} = {}) {
  const hasCoord =
    lat !== "" && lat != null && lng !== "" && lng != null &&
    !Number.isNaN(Number(lat)) && !Number.isNaN(Number(lng));
  return {
    deployment_type: "infrastructure",
    hardware_capability: hardwareCapability || "core",
    operational_identifier: (operationalIdentifier || "").trim(),
    category: category || null,
    display_name: (displayName || "").trim() || null,
    notes: (notes || "").trim() || null,
    location: hasCoord
      ? {
          lat: Number(lat),
          lng: Number(lng),
          accuracy_m: accuracyM != null ? Number(accuracyM) : null,
          location_source: locationSource || "manual",
        }
      : null,
  };
}
